export default {
  props: {
    show: {
      type: Boolean
    }
  },
  data() {
    return {
      img: require("@/assets/pc/common/batch.jpg")
    };
  },
  methods: {
    batchClose() {
      this.$parent.closeBatch();
    }
  }
};